module.exports = __webpack_public_path__ + "img/cartoonHead2-3.a73f0ee5.png";